import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % featuredComics.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const currentComic = featuredComics[current];

  return (
    <section className="relative h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={currentComic.coverImage}
          alt={currentComic.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="max-w-2xl" key={currentComic.id}>
            <div className="animate-fadeInUp">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 mb-4">
                {currentComic.status === '连载中' ? '🔥 热门连载' : '✨ 推荐佳作'}
              </span>
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3 leading-tight">
                {currentComic.title}
              </h1>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 line-clamp-3 max-w-lg">
                {currentComic.description}
              </p>
              <div className="flex flex-wrap items-center gap-4 text-xs md:text-sm text-background-50/70 mb-6">
                <span className="flex items-center gap-1">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-user-line"></i></span>
                  {currentComic.author}
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill text-accent-500"></i></span>
                  {currentComic.rating}
                </span>
                <span>{currentComic.totalChapters}话</span>
                <span>{(currentComic.totalViews / 10000).toFixed(0)}万阅读</span>
              </div>
              <div className="flex items-center gap-3">
                <Link
                  to={`/comic/${currentComic.id}`}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  立即阅读
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </Link>
                <Link
                  to={`/category/${currentComic.categorySlug}`}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 rounded-lg font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  更多{currentComic.category}漫画
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {featuredComics.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'bg-accent-500 w-6'
                : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
            aria-label={`跳转到第${index + 1}张`}
          />
        ))}
      </div>

      <button
        onClick={() => setCurrent((prev) => (prev - 1 + featuredComics.length) % featuredComics.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % featuredComics.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>
    </section>
  );
}